/* eslint-disable react/react-in-jsx-scope */
import { Box, Card, List, ListItem, ListItemText, ListItemSecondaryAction, Tooltip, IconButton, SvgIcon, Typography, Divider } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { navigateToDocumentWithHighlight } from './navigateToDocument';
/* eslint-disable no-unused-vars */
export const References = ({ resources = [], extension }) => {
    // Deduplicate resources based on title and URL.
    const uniqueResources = resources.filter((resource, index, self) =>
        index === self.findIndex((t) => (
            t.title === resource.title && t.url === resource.url
        ))
    );

    // Filter out resources without a source_id
    const resourcesWithSourceId = uniqueResources.filter(resource => resource.source_id && resource.title);

    return (
        <Box>
            {resourcesWithSourceId.length > 0 && (
                <Card>
                    <Divider />
                    <List>
                        {resourcesWithSourceId.map((resource, index) => (
                            <ListItem key={index} divider>
                                <ListItemText>
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="subtitle2" mr={1} fontWeight={resource.inlineUsed ? 'bold' : 'normal'}>
                                            {resource.source_id}.
                                        </Typography>
                                        <Typography variant="body2" color={resource.inlineUsed ? 'text.primary' : 'text.secondary'}>
                                            {resource.title}
                                        </Typography>
                                    </Box>
                                </ListItemText>
                                <ListItemSecondaryAction>
                                    <Tooltip title="Citation">
                                        <IconButton edge="end" onClick={async () => await navigateToDocumentWithHighlight(resource, extension, false)}>
                                            <SvgIcon>
                                                <ChevronRightIcon />
                                            </SvgIcon>
                                        </IconButton>
                                    </Tooltip>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                </Card>
            )}
        </Box>
    );
};
